import React, { useMemo, useCallback } from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

import SSRSafeElement from 'commons/SSRSafeElement';
import BaseField from './BaseField';

const SmartyStreetsFloatingField = ({
  id = 'address',
  name = 'address',
  value,
  error,
  showError,
  isTouched,
  handleBlur,
  handleChange,
  setFieldValue,
  updateShipping,
  isRequired = true,
  refField = null,
  ...props
}) => {
  const updateShippingDebounced = useMemo(
    () =>
      debounce(updatedValue => {
        if (!error && updatedValue) {
          updateShipping?.({ address: updatedValue });
        }
      }, 400),
    [updateShipping, error]
  );

  const changeHandler = useCallback(
    evt => {
      handleChange(evt);
      updateShippingDebounced(evt.target.value);
    },
    [handleChange, updateShippingDebounced]
  );

  return (
    <Field
      id={id}
      name={name}
      render={({ field }) => (
        <BaseField
          type="text"
          field={field}
          value={value}
          onBlur={evt => {
            handleBlur(evt);

            if (!error) {
              updateShipping?.();
            }
          }}
          onChange={changeHandler}
          setFieldValue={setFieldValue}
          placeholder="Street address *"
          autoComplete="address-line1"
          errorstate={isTouched && error}
          data-xc="shipping-address-field"
          required={isRequired ? '' : undefined}
          aria-required={isRequired ? '' : undefined}
          refField={refField}
          errorMessage={showError && isTouched && error}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      )}
    />
  );
};

SmartyStreetsFloatingField.propTypes = {
  addressFieldName: PropTypes.string,
  stateFieldName: PropTypes.string,
  cityFieldName: PropTypes.string,
  zipCodeFieldName: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  showError: PropTypes.bool,
  isTouched: PropTypes.bool,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  setFieldValue: PropTypes.func,
  isRequired: PropTypes.bool,
  updateShipping: PropTypes.func,
  refField: PropTypes.shape({
    current: PropTypes.instanceOf(SSRSafeElement),
  }),
};

export default SmartyStreetsFloatingField;
